import * as React from 'react';
import { Row, Col, Icon, Button, message, Tooltip, Form } from 'antd';
import { MOBILE_BREAK_POINT } from 'src/globals';
import injectSheet from 'react-jss';
import QuoteConfirmationModal from '../Modals/QuoteConfirmationModal';
import QuoteRejectionModal from '../Modals/QuoteRejectionModal';
import moment from 'moment';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { confirmBid, declineBid, deleteBidForShipper } from 'src/api/inquiry';
import { resetFilters, applyFilter } from 'src/actions/inquiryShipperActionsBids';
import { bindActionCreators } from 'redux';
import ViewBreakdown from 'src/components/pages/Enquiry/Modals/ViewBreakdown';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import DeleteBidConfirmationModal from '../Modals/DeleteBidConfirmationModal';
import DeleteBidSuccessModal from '../Modals/DeleteBidSuccessModal';
import { getInquiryDetailRoute } from 'src/routing/utils';
import CommentCount from '../../../common/comments/CommentCount';
import { BID_ROUTES_CARD_LABELS, getBidTotal , inquiryOptionsMap } from '../InquiryUtils';
import { fetchCardData } from 'src/actions/dashboardActions';
import { formatDateFromObject, formatPrice, isNumberDecimal } from 'src/utils/utils';
import { isValidArray, getDateValue } from 'src/Library/Helper';
import { sendEvent, EventCategories } from 'src/utils/gaService';
import isEmpty from 'lodash/isEmpty';
import { InquiryModes } from 'src/Library/Constants';
import FieldRate from 'src/components/common/form/FieldRate';
import { tokens } from 'src/design-system';

const styles = (theme) => ({
  parentDiv: {
    '& .ant-btn': {
      boxShadow: '0 0 0 rgba(0,0,0,0) !important',
    },
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
    margin: '8px 2px 8px 2px',
  },
  cardHeaderItemsStyle: {
    fontSize: `${tokens.fontSize.small}px`,
    marginBottom: '10px',
    color: '#595959',
  },
  info: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '44%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  dateStyle: {
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#111',
    float: 'right',
    width: '73%',
    padding: '0px 0px 0px 5px',
    lineHeight: '100%',
  },
  cardIcon: {
    margin: '0px 0px 0px 2px',
    fontSize: `${tokens.fontSize.h2}px`,
  },
  cardDeleteIcon: {
    padding: '10px',
  },
  cardEditIcon: {
    padding: '10px',
  },
  viewDetailsStyle: {
    fontSize: `${tokens.fontSize.small}px`,
    margin: '5px 0px 0px 0px',
    color: tokens.colors.primary,
  },
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    parentDiv: {
      padding: 0,
    },
  },
  iconToolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  rank: {
    backgroundColor: '#C5E7F5',
    height: '41px',
    color: tokens.colors.textSecondary,
    fontSize: `${tokens.fontSize.body}px`,
    fontWeight: tokens.fontWeight.semibold,
    padding: '0px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  rankDiv: {
    backgroundColor: '#3B45C2',
    color: tokens.colors.bgWhite,
    display: 'flex',
    justifyContent: 'center',
    borderRadius: `${tokens.radius.md}px`,
  },
  generalDetailsLogo: {
    borderBottom: '1px solid #E9E9E9',
  },
  generalDetailsContent: {
    color: '#262626',
    fontSize: `${tokens.fontSize.body}px`,
    borderBottom: '1px solid #E9E9E9',
    padding: '7px 0px 8px 0px',
    fontWeight: tokens.fontWeight.semibold,
    marginBottom: 0,
    height: '37px',
  },
  totalPrice: {
    backgroundColor: '#00628B',
    color: tokens.colors.bgWhite,
    fontSize: '21px',
    padding: '11px 20px',
  },
  colStyle: {
    display: 'flex',
    padding: '0px 16px',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontSize: `${tokens.fontSize.h3}px`,
  },
  pol: {
    width: '153px',
    whiteSpace: 'nowrap',
    overflow: 'hidden !important',
    display: 'inline-block',
    textOverflow: 'ellipsis',
  },
  totalCurrencySymbol: {
    fontSize: `${tokens.fontSize.small}px`,
    verticalAlign: 'top',
    lineHeight: '23px',
  },
  chargesCurrencySymbol: {
    verticalAlign: 'top',
    lineHeight: '25px',
  },
  priceCurrencySymbol: {
    verticalAlign: 'top',
    fontSize: `${tokens.fontSize.caption}px`,
    lineHeight: '18px',
  },
  perUnitPrice: {
    color: '#000000',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ffName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  locationDetails: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '117px',
  },
});

const info = () => {
  message.success('Your bid has been sent.');
};
class BidCardShipper extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      isCardLoading: false,
      confirmModalVisible: false,
      rejectModalVisible: false,
      viewBreakDownVisible: false,
      deleteBidModalVisible: false,
      commentVisible: false,
      deleteSuccess: false,
      deletionReason: '',
      isSaving: false,
    };
  }

  handleConfirm = async (closeInquiry, reason) => {
    const { id: inquiryId, confirmedBidId, shipperId } = this.props.inquiryData;
    const { id: bidId } = this.props.cardData;
    this.setState({ isCardLoading: true });
    await confirmBid({
      bidIds: [bidId],
      inquiryId,
      shipperId,
      closeInquiry,
      reasonForNonL1BidConfirmation: reason,
    })
      .then((res) => {
        if (res.isSuccess) {
          this.props.resetFilters(inquiryId);
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to confirm the quote? - yes'
          );
        } else {
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to confirm the quote? - yes (Failed)'
          );
          message.error('Unable to handle request');
        }
      })
      .then(() => {
        this.setState({ confirmModalVisible: false });
        this.props.refreshInquiryData();
      });
    this.setState({ isCardLoading: false });
    this.setState({
      confirmModalVisible: false,
      rejectModalVisible: false,
    });
  };

  handleCommentSubmit = () => {
    if (!this.state.deletionReason) {
      message.error('Reason is required');
      this.setState({
        creating: false,
      });
      return;
    }
    this.setState({ commentVisible: false });
  };

  handleDecline = async (deadlineDate) => {
    const { id: inquiryId } = this.props.inquiryData;
    const { shipperId } = this.props.inquiryData;
    const { id: bidId } = this.props.cardData;
    const deadline = deadlineDate
      ? {
          dateString: moment(deadlineDate).format('YYYY-MM-DD'),
          time: moment(deadlineDate).format('HH:mm'),
        }
      : undefined;
    this.setState({ isCardLoading: true });
    await declineBid({ bidId, inquiryId, shipperId, deadline })
      .then((res) => {
        if (res.isSuccess) {
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to decline the quote? - yes'
          );
          this.props.resetFilters(this.props.inquiryId);
        } else {
          sendEvent(
            EventCategories.INQUIRY_BID_CONFIRMATION,
            'Are you sure, you want to decline the quote? - yes (Failed)'
          );
          message.error('Unable to handle request');
        }
      })
      .then(() => {
        this.setState({ rejectModalVisible: false });
        this.props.refreshInquiryData();
      });
    this.setState({ isCardLoading: false });
  };

  renderButton = () => {
    const {
      permissions: { INQUIRY_CONFIRM_DECLINE_ACTIONS },
    } = this.props;
    if (!INQUIRY_CONFIRM_DECLINE_ACTIONS || this.props.cardData.isDeletedByShipper) return;

    const isDisabled = false; // https://shipsy.atlassian.net/browse/CORE-13127
    // const isDisabled = this.props.bidData.find((item) => item.isConfirmed === true);
    return (
      <Button
        type="primary"
        style={{
          backgroundColor: `${isDisabled ? '#999999' : '#17AC27'}`,
          margin: '14px 0px',
          borderColor: `${isDisabled ? '#999999' : '#17AC27'}`,
          fontSize: `${tokens.fontSize.body}px`,
          cursor: isDisabled ? 'default' : 'pointer',
          height: '28px',
        }}
        onClick={isDisabled ? undefined : this.showQuoteConfirmationModal}
      >
        Confirm
      </Button>
    );
  };

  showQuoteConfirmationModal = () => {
    this.setState({
      confirmModalVisible: true,
    });
  };

  showQuoteRejectionModal = () => {
    this.setState({
      rejectModalVisible: true,
    });
  };

  quoteConfirmModalHandleCancel = () => {
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'Are you sure, you want to confirm the quote? - no'
    );
    this.setState({
      confirmModalVisible: false,
    });
  };

  quoteRejectModalHandleCancel = () => {
    sendEvent(
      EventCategories.INQUIRY_BID_CONFIRMATION,
      'Are you sure, you want to decline the quote? - no'
    );
    this.setState({
      rejectModalVisible: false,
    });
  };

  toggleConfirm = (closeOrReopenInquiry, reason = '') => {
    if (this.props.cardData.isConfirmed) {
      this.handleDecline(closeOrReopenInquiry);
    } else {
      closeOrReopenInquiry === 'INQUIRY_CLOSED'
        ? this.handleConfirm(true, reason)
        : this.handleConfirm(false, reason);
    }
  };

  handleViewBreakDown = () => {
    this.setState({ viewBreakDownVisible: true });
  };

  closeViewBreakdown = () => {
    this.setState({ viewBreakDownVisible: false });
  };

  handleOkViewBreakDown = () => {
    this.setState({ viewBreakDownVisible: false });
  };

  handleOnChangeReason = (event) => {
    this.setState({ deletionReason: event.target.value });
  };

  handleDeleteBid = async () => {
    if (!this.state.deletionReason) {
      message.error('Reason is required');
      this.setState({
        creating: false,
      });
      return;
    }
    this.setState({ isCardLoading: true });
    await deleteBidForShipper(this.props.cardData.id, this.state.deletionReason)
      .then((res) => {
        if (res.isSuccess) {
          this.setState({ deleteSuccess: true });
        } else {
          message.error('Unable to delete Bid');
        }
      })
      .then(() => this.setState({ deleteBidModalVisible: false }));
    this.setState({ isCardLoading: false });
  };

  deadlineMissed = (deadline) => {
    const currentTime = moment();
    return currentTime.diff(moment(deadline), 'minutes') >= 0;
  };

  renderconfirmedStatus = () => {
    const {
      permissions: { INQUIRY_CONFIRM_DECLINE_ACTIONS },
      cardData,
      inquiryData,
    } = this.props;
    return (
      <div style={{ paddingLeft: cardData.isConfirmed ? '20px' : undefined }}>
        <div style={{ fontSize: `${tokens.fontSize.body}px`, margin: '12px 0px 0px 0px', position: 'relative' }}>
          <Icon
            type="check-circle"
            theme="filled"
            style={{ color: '#44D13D', position: 'absolute', left: '-20px', bottom: '4px' }}
          />
          <span style={{ fontWeight: 600 }}> Confirmed Bid</span>
        </div>
        {INQUIRY_CONFIRM_DECLINE_ACTIONS && (
          <div style={{ paddingBottom: '6px' }}>
            <a
              style={{ fontWeight: tokens.fontWeight.semibold, color: '#F5222D', fontSize: `${tokens.fontSize.small}px` }}
              onClick={this.showQuoteRejectionModal}
            >
              Decline Bid
            </a>
            <QuoteRejectionModal
              visible={this.state.rejectModalVisible}
              loading={this.state.isCardLoading}
              handleOk={this.toggleConfirm}
              handleCancel={this.quoteRejectModalHandleCancel}
              options={
                this.deadlineMissed(inquiryData.deadline) ? inquiryOptionsMap.reject : undefined
              }
            />
          </div>
        )}
      </div>
    );
  };

  showDeleteBidModal = () => {
    this.setState({
      deleteBidModalVisible: true,
    });
  };

  DeleteBidModalHandleCancel = () => {
    this.setState({
      deleteBidModalVisible: false,
      commentVisible: false,
    });
  };

  handleDeleteSuccessOkay = () => {
    this.setState({ deleteSuccess: false });
    this.props.applyFilter(this.props.inquiryData.id);
  };

  renderCarrierInfo = (cardData, classes) => {
    return (
      <div className={classes.generalDetailsLogo}>
        {cardData.carrierLogoUrl ? (
          <div style={{ paddingBottom: '5px' }}>
            <div
              style={{
                height: '25px',
                width: '100px',
                backgroundImage: `url("${cardData.carrierLogoUrl}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }}
            ></div>
          </div>
        ) : (
          <div style={{ paddingBottom: '7px' }}>{cardData.ffCarrierName}</div>
        )}
      </div>
    );
  };

  renderValidTill = (cardData, classes) => {
    return (
      <div className={classes.generalDetailsContent}>
        {cardData.validTill ? moment(new Date(cardData.validTill)).format('DD MMM YYYY') : '-'}
      </div>
    );
  };

  renderPol = (inquiryData, classes) => {
    return (
      <div className={classes.generalDetailsContent} style={{ padding: '6px 0px 4px 0px' }}>
        {inquiryData && inquiryData.originPortDetails ? (
          <div className={classes.pol}>
            <Tooltip title={inquiryData.originPortDetails && inquiryData.originPortDetails?.name}>
              <img
                src={inquiryData.originPortDetails && inquiryData.originPortDetails?.flagS3Link}
              />
              <span style={{ marginLeft: '5px' }}>
                {inquiryData.originPortDetails && inquiryData.originPortDetails?.name}
              </span>
            </Tooltip>
          </div>
        ) : (
          '-'
        )}
      </div>
    );
  };

  renderPod = (inquiryData, classes) => {
    return (
      <div className={classes.generalDetailsContent} style={{ padding: '6px 0px 4px 0px' }}>
        {inquiryData && inquiryData.destinationPortDetails ? (
          <div className={classes.pol}>
            <Tooltip title={inquiryData.destinationPortDetails && inquiryData.destinationPortDetails?.name}>
              <img
                src={inquiryData.destinationPortDetails && inquiryData.destinationPortDetails?.flagS3Link}
              />
              <span style={{ marginLeft: '5px' }}>
                {inquiryData.destinationPortDetails && inquiryData.destinationPortDetails?.name}
              </span>
            </Tooltip>
          </div>
        ) : (
          '-'
        )}
      </div>
    );
  };

  renderRoundTripTime = (cardData, classes) => {
    return (
      <div className={classes.generalDetailsContent}>
        {!isEmpty(cardData.otherDetails?.roundTripTime) ? (
          <span>
            {cardData.otherDetails?.roundTripTime?.value}{' '}
            {cardData.otherDetails?.roundTripTime?.type}
          </span>
        ) : (
          '-'
        )}
      </div>
    );
  };

  renderDetentionCostPerDay = (cardData, classes) => {
    const { currency } = this.props;
    return (
      <div className={classes.generalDetailsContent}>
        {!isEmpty(cardData.otherDetails?.detentionCostPerDay) ? (
          <span>
            {currency[`${cardData.otherDetails?.detentionCostPerDay?.currency}`]}
            {cardData.otherDetails?.detentionCostPerDay?.amount}
          </span>
        ) : (
          '-'
        )}
      </div>
    );
  };

  renderRow3 = () => {
    const { classes, cardData, inquiryData, generalDetailsKeys } = this.props;
    const transitValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.transitDays ?? '-'}
      </div>
    );
    const stuffingValue = (
      <div className={classes.generalDetailsContent} style={{ display: 'flex' }}>
        {inquiryData?.originLocationDetails?.flagS3Link ? (
          <>
            <Tooltip title={inquiryData?.originLocationDetails?.countryName}>
              <img
                src={inquiryData?.originLocationDetails?.flagS3Link}
                style={{ width: '27px', height: '19px', marginRight: '5px' }}
              />
            </Tooltip>
          </>
        ) : (
          ''
        )}
        <div className={classes.locationDetails}>
          {(inquiryData?.originLocationDetails?.name ||
            inquiryData?.originLocationDetails?.city ||
            inquiryData?.originLocationDetails?.locationType) ??
            '-'}
        </div>
        <Tooltip title={inquiryData?.originLocationDetails?.displayAddress}>
          <Icon type="exclamation-circle" style={{ marginLeft: '5px' }} />
        </Tooltip>
      </div>
    );
    const destuffingValue = (
      <div className={classes.generalDetailsContent} style={{ display: 'flex' }}>
        {inquiryData?.destinationLocationDetails?.flagS3Link ? (
          <>
            <Tooltip title={inquiryData?.destinationLocationDetails?.countryName}>
              <img
                src={inquiryData?.destinationLocationDetails?.flagS3Link}
                style={{ width: '27px', height: '19px', marginRight: '5px' }}
              />
            </Tooltip>
          </>
        ) : (
          ''
        )}
        <div className={classes.locationDetails}>
          {(inquiryData?.destinationLocationDetails?.name ||
            inquiryData?.destinationLocationDetails?.city ||
            inquiryData?.destinationLocationDetails?.locationType) ??
            '-'}
        </div>
        <Tooltip title={inquiryData?.destinationLocationDetails?.displayAddress}>
          <Icon type="exclamation-circle" style={{ marginLeft: '5px' }} />
        </Tooltip>
      </div>
    );
    const scheduleValue = (
      <div className={classes.generalDetailsContent}>
        {cardData.otherDetails &&
        cardData.otherDetails.schedule &&
        cardData.otherDetails.schedule.length > 0
          ? cardData.otherDetails.schedule.map((item) => (
              <span style={{ marginRight: '5px' }}>{item.toUpperCase()}</span>
            ))
          : '-'}
      </div>
    );
    const transshipmentValue = (
      <div className={classes.generalDetailsContent}>
        {cardData.otherDetails?.transshipmentVia ? (
          isValidArray(cardData.otherDetails.transshipmentVia) ? (
            <span>
              <Tooltip
                title={cardData.otherDetails.transshipmentVia.map((item) => (
                  <div>{item.label}</div>
                ))}
              >
                {cardData.otherDetails.transshipmentVia[0].label}
                {cardData.otherDetails.transshipmentVia.length > 1 ? (
                  <>&nbsp;+&nbsp;{cardData.otherDetails.transshipmentVia.length - 1}</>
                ) : (
                  ''
                )}
              </Tooltip>
            </span>
          ) : (
            '-'
          )
        ) : (
          <span style={{ fontSize: `${tokens.fontSize.caption}px`, fontWeight: 'normal' }}>Not Available</span>
        )}
      </div>
    );

    const etdValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.etd ? getDateValue(cardData?.otherDetails?.etd)?.format('DD MMM YYYY') : '-'}
      </div>
    );

    const siCutOffValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.siCutOff ? getDateValue(formatDateFromObject(cardData?.otherDetails?.siCutOff))?.format('DD MMM YYYY') : '-'}
      </div>
    );

    const etaValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.eta ? getDateValue(formatDateFromObject(cardData?.otherDetails?.eta))?.format('DD MMM YYYY') : '-'}
      </div>
    );

    const alternateVesselScheduleValue = (
      <div className={classes.generalDetailsContent}>
        {(() => {
          const fullText = cardData?.otherDetails?.alternateVesselSchedule || '-';
          const truncated = fullText && fullText.length > 10 ? `${fullText.slice(0, 10)}...` : fullText || '-';
          return (
            <Tooltip title={fullText}>
              <span>{truncated}</span>
            </Tooltip>
          );
        })()}
      </div>
    );
    
    const allowedCargoWeightValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.allowedCargoWeight || '-'}
      </div>
    );

    const routeValue = (
      <div className={classes.generalDetailsContent}>
        {cardData?.otherDetails.route
          ?.map((item) => BID_ROUTES_CARD_LABELS[item] || item)
          .join(', ') || '-'}
      </div>
    );
    
    let updatedInquiryData = inquiryData;
    if (inquiryData.otherDetails?.allowVendorToSpecifyOrigin && cardData.origin) {
      updatedInquiryData = {
        ...inquiryData,
        originPortDetails: cardData.origin,
      };
    }
    if (inquiryData.otherDetails?.allowVendorToSpecifyDestination && cardData.destination) {
      updatedInquiryData = {
        ...updatedInquiryData,
        destinationPortDetails: cardData.destination,
      };
    }
    
    return (
      <div
        className={classes.colStyle}
        style={{ height: this.props.getColumnHeight(generalDetailsKeys) }}
      >
        {/* TODO (code-cleanup): Find a better way for this conditional! */}
        {generalDetailsKeys.map((item) => {
          switch (item) {
            case 'Vendor Rating':
              return this.renderVendorRating(cardData, classes);
            case 'Carrier':
              return this.renderCarrierInfo(cardData, classes);
            case 'Bid Validity':
              return this.renderValidTill(cardData, classes);
            case 'POL':
              return this.renderPol(updatedInquiryData, classes);
            case 'POD':
              return this.renderPod(updatedInquiryData, classes);
            case 'SI Cut Off':
              return siCutOffValue;
            case 'ETD':
              return etdValue;
            case 'ETA':
              return etaValue;
            case 'Transit Days':
              return transitValue;
            case 'Schedule':
              return scheduleValue;
            case 'Route':
              return routeValue;
            case 'Alternate Vessel Schedule':
              return alternateVesselScheduleValue;
            case 'Allowed Cargo Weight (Kg)':
              return allowedCargoWeightValue;
            case 'Transshipment':
              return transshipmentValue;
            case 'Round Trip Time':
              return this.renderRoundTripTime(cardData, classes);
            case 'Detention Cost Per Day':
              return this.renderDetentionCostPerDay(cardData, classes);
            case 'Stuffing Location':
              return stuffingValue;
            case 'Delivery Location':
              return destuffingValue;
            default:
              return '';
          }
        })}
      </div>
    );
  };

  netPriceTooltip = () => {
    const { cardData, currency, inquiryData } = this.props;
    if (cardData?.mode === InquiryModes.DOMESTIC && cardData?.shipperTotalWithoutTax?.currency) {
      return (
        <>
          {getBidTotal(
            cardData?.exchangeRateDate
              ? cardData?.userTotalWithoutTax?.amount
              : cardData?.shipperTotalWithoutTax?.amount
          )}
          &nbsp;
          {cardData?.exchangeRateDate
            ? cardData?.userTotalWithoutTax?.currency
            : cardData?.shipperTotalWithoutTax?.currency}
        </>
      );
    }
    return (
      <>
        <span>
          {cardData.totalPerUnit &&
            cardData.totalPerUnit.amount &&
            getBidTotal(cardData.totalPerUnit.amount)}
          &nbsp;{cardData.totalPerUnit && cardData.totalPerUnit.currency}
        </span>
        <span>
          {InquiryModes.DOMESTIC !== inquiryData?.mode ? (
            <span style={{ fontSize: `${tokens.fontSize.body}px`, textTransform: 'capitalize' }}>
              {cardData.totalPerUnit.format ? ` / ${cardData.totalPerUnit.format}` : ''}
            </span>
          ) : (
            ''
          )}
        </span>
      </>
    );
  };

  renderRow2 = () => {
    const {
      classes,
      cardData,
      inquiryData,
      currency,
      exchangeRates,
      userCurrency,
      permissions: { INQUIRY_CONFIRM_DECLINE_ACTIONS },
    } = this.props;
    const currentTimeMilisec = new Date().getTime();
    const netPriceAmount =
      cardData?.mode === InquiryModes.DOMESTIC
        ? cardData?.exchangeRateDate
          ? cardData?.userTotalWithoutTax?.amount
          : cardData?.shipperTotalWithoutTax?.amount
        : cardData?.totalPerUnit?.amount;
    const netPriceCurrency =
      userCurrency && cardData?.exchangeRateDate
        ? userCurrency
        : cardData?.mode === InquiryModes.DOMESTIC
        ? cardData?.exchangeRateDate
          ? cardData?.userTotalWithoutTax?.currency
          : cardData?.shipperTotalWithoutTax?.currency
        : cardData?.totalPerUnit?.currency;
    return (
      <Row
        style={{
          padding: '12px 12px 0px 12px',
          borderBottom: '1px solid #D9D9D9',
          height: '126px',
        }}
      >
        <Col span={18}>
          {!cardData ? (
            ''
          ) : (
            <div style={{ padding: cardData.isDeletedByShipper ? '20px 0px 40px 0px' : undefined }}>
              <div className={classes.perUnitPrice}>
                <Tooltip title={this.netPriceTooltip()}>
                  <span style={{ fontWeight: 600 }}>
                    <span style={{ fontSize: '21px' }}>
                      {netPriceAmount !== undefined && formatPrice(getBidTotal(netPriceAmount))}
                    </span>
                    <span className={classes.chargesCurrencySymbol}>&nbsp;{netPriceCurrency}</span>
                    {InquiryModes.DOMESTIC !== inquiryData?.mode ? (
                      <span style={{ fontSize: `${tokens.fontSize.body}px` }}>
                        {cardData.totalPerUnit.format ? ` / ${cardData.totalPerUnit.format}` : ''}
                      </span>
                    ) : (
                      ''
                    )}
                  </span>
                </Tooltip>
              </div>
              <a className={classes.viewDetailsStyle} onClick={this.handleViewBreakDown}>
                View Details
              </a>
              {this.state.viewBreakDownVisible && (
                <ViewBreakdown
                  mode={inquiryData?.mode}
                  inquiryId={inquiryData.id}
                  type={'SHIPPER'}
                  visible={this.state.viewBreakDownVisible}
                  bidId={cardData.id}
                  handleCancel={this.closeViewBreakdown}
                  handleOk={this.handleOkViewBreakDown}
                />
              )}
              {cardData.isConfirmed ? this.renderconfirmedStatus() : this.renderButton()}
              <QuoteConfirmationModal
                visible={this.state.confirmModalVisible}
                inquiryData={inquiryData}
                bidData={cardData}
                captureReasonForNonL1Bid={this.props.captureReasonForNonL1Bid}
                topBidData={this.props.topBidData}
                isLoading={this.state.isCardLoading}
                handleOk={this.toggleConfirm}
                loading={this.state.isCardLoading}
                handleCancel={this.quoteConfirmModalHandleCancel}
                options={
                  inquiryData.deadline - currentTimeMilisec > 0
                    ? inquiryOptionsMap.confirm
                    : undefined
                }
              />
            </div>
          )}
        </Col>
        <Col span={6} className={classes.iconToolbar}>
          {(this.props.showInquiryComments && !this.props.isParentOrg) && (
            <CommentCount
            prefetchedCount={cardData.commentCount}
              commentApiPrefix={'inquiry/bid'}
              style={{
                float: 'right',
              }}
              sourceObjectId={cardData.baseRevisionBidId}
              modalHeader={
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      color: '#262626',
                      alignSelf: 'center',
                      fontSize: `${tokens.fontSize.h2}px`,
                      fontWeight: tokens.fontWeight.semibold,
                      marginLeft: '15px',
                    }}
                  >
                    {cardData.ffName}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginRight: '12px',
                    }}
                  >
                    <div style={{ marginTop: '8px', marginRight: '68px' }}>
                      <img src={cardData.carrierLogoUrl} />
                    </div>
                    <div>
                      <PriceTotal
                        commentTextStyle={true}
                        amount={
                          cardData?.exchangeRateDate
                            ? cardData.userTotalWithoutTax.amount
                            : cardData.shipperTotalWithoutTax.amount
                        }
                        currencySymbol={
                          cardData?.exchangeRateDate
                            ? cardData.userTotalWithoutTax.currency
                            : cardData.shipperTotalWithoutTax.currency
                        }
                        source={'INQUIRY'}
                      />
                      {InquiryModes.DOMESTIC === cardData?.mode ? (
                        ''
                      ) : (
                        <PricePerContainer
                          commentTextStyle={true}
                          amount={cardData.totalPerUnit && cardData.totalPerUnit.amount}
                          currency={cardData.totalPerUnit && cardData.totalPerUnit.currency}
                          containerTypes={cardData.totalPerUnitType}
                          mode={cardData.mode}
                          sourceObjectType={'BID'}
                          totalPrice={
                            cardData?.exchangeRateDate
                              ? cardData.userTotalWithoutTax
                              : cardData.shipperTotalWithoutTax
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
              }
            />
          )}
          {!cardData.isDeletedByShipper &&
          !cardData.isConfirmed &&
          INQUIRY_CONFIRM_DECLINE_ACTIONS ? (
            <div>
              <Icon
                type="delete"
                style={{ fontSize: `${tokens.fontSize.h2}px`, cursor: 'pointer' }}
                onClick={() => this.showDeleteBidModal()}
              />

              <DeleteBidConfirmationModal
                visible={this.state.deleteBidModalVisible}
                ffName={cardData.ffName}
                handleOk={
                  this.state.commentVisible ? this.handleCommentSubmit : this.handleDeleteBid
                }
                handleCancel={this.DeleteBidModalHandleCancel}
                commentVisible={this.state.commentVisible}
                onChangeReason={this.handleOnChangeReason}
                value={this.state.deletionReason}
                loading={this.state.isCardLoading}
              />

              <DeleteBidSuccessModal
                visible={this.state.deleteSuccess}
                ffName={cardData.ffName}
                referenceNumber={inquiryData.referenceNumber}
                handleOk={this.handleDeleteSuccessOkay}
              />
            </div>
          ) : null}
        </Col>
      </Row>
    );
  };

  renderRow1 = () => {
    const { cardData, classes } = this.props;
    return (
      <div className={classes.rank}>
        <Tooltip title={cardData.ffName}>
          <span className={classes.ffName}>{cardData.ffName}</span>
        </Tooltip>
        <span style={{ padding: '7px 0px' }}>
          <div className={classes.rankDiv}>{cardData.rank}</div>
          <div style={{ fontSize: '8px', fontWeight: 500 }}>Rank</div>
        </span>
      </div>
    );
  };

  renderValues = (chargeValue, data) => {
    const values = data?.values;
    const { classes, currency, userCurrency, exchangeRateDate } = this.props;
    let i;
    const dataValue: any = [];
    let temp: any = '-';
    for (i of chargeValue.slice(0, -1)) {
      //added slice to avoid 'Sub Total of X Charges'
      temp = '-';
      values?.map((item) => {
        if (item.name?.toLowerCase() === i?.toLowerCase()) {
          temp = (
            <>
              <span style={{ fontSize: `${tokens.fontSize.body}px` }}>
                {getBidTotal(exchangeRateDate ? item.userPrice.amount : item.price)}
              </span>
              <span>&nbsp;{exchangeRateDate ? item.userPrice.currency : item.currency}</span>
              {item.unitType ? (
                <span style={{ fontSize: '8px' }}>
                  {/* slice(4, ..) to remove the 'PER ' from 'PER UNIT' value
              from the backend key 'unitType' */}
                  &nbsp;/{item.unitType.slice(4, item.unitType.length)}
                </span>
              ) : (
                ''
              )}
              <span style={{ fontSize: `${tokens.fontSize.small}px`, fontWeight: 600 }}>
                {item.unitCount ? (
                  <span style={{ fontSize: '8px' }}>
                    &nbsp;&nbsp;x&nbsp;&nbsp;
                    <span style={{ fontSize: `${tokens.fontSize.caption}px` }}>
                      {isNumberDecimal(item.unitCount) ? item.unitCount.toFixed(2) : item.unitCount}
                    </span>{' '}
                    units
                  </span>
                ) : (
                  ''
                )}
              </span>
            </>
          );
        }
      });
      dataValue.push(temp);
    }

    const totalChargeCategoryData = data?.userTotalWithoutTax || data?.shipperTotalWithoutTax;
    const totalChargeCategory = (
      <>
        <span style={{ fontSize: `${tokens.fontSize.body}px` }}>{getBidTotal(totalChargeCategoryData.amount)}</span>
        <span>&nbsp;{totalChargeCategoryData.currency}</span>
      </>
    );
    dataValue.push(totalChargeCategory);

    return dataValue.map((item) => {
      return (
        <p
          className={classes.generalDetailsContent}
          style={{ fontSize: `${tokens.fontSize.h3}px`, padding: '6px 0px 7px 0px' }}
        >
          {item}
        </p>
      );
    });
  };

  renderTotal = () => {
    const {
      classes,
      cardData,
      currency,
      exchangeRates,
      userCurrency,
      exchangeRateDate,
    } = this.props;
    const amount = exchangeRateDate
      ? cardData?.userTotalWithoutTax?.amount
      : cardData.shipperTotalWithoutTax.amount;
    const curr = exchangeRateDate
      ? cardData?.userTotalWithoutTax?.currency
      : cardData.shipperTotalWithoutTax.currency;
    return (
      <div className={classes.totalPrice}>
        {amount && getBidTotal(amount)}
        <span>&nbsp;{curr}</span>
      </div>
    );
  };

  renderFreeDays = () => {
    const { classes, cardData, freeDaysKeys } = this.props;
    const originFreeDays =
      <p className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.originFreeDays ?? '-'}
      </p>
    const demurrageFreeDays =
      <p className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.demurrageFreeDays ?? '-'}
      </p>
    const detentionFreeDays = (
      <p className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.detentionFreeDays ?? '-'}
      </p>
    );
    const cfsFreeDays =
      <p className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.cfsFreeDays ?? '-'}
      </p>
    const combinedFreeDays =
      <p className={classes.generalDetailsContent}>
        {cardData?.otherDetails?.combinedFreeDays ?? '-'}
      </p>
    return (
      <div style={{ paddingBottom: '0px' }}>
        {/* TODO (code-cleanup): Find a better way for this conditional! */}
        {freeDaysKeys.map((item) => {
          switch (item) {
            case 'Origin Free Days':
              return originFreeDays;
            case 'Demurrage Free Days':
              return demurrageFreeDays;
            case 'Detention Free Days':
              return detentionFreeDays;
            case 'CFS Free Days':
              return cfsFreeDays;
            case 'Combined Free Days':
              return combinedFreeDays;
            default:
              return '';
          }
        })}
      </div>
    );
  };

  renderVendorRating = (cardData, classes) => {
    const { ffRating } = cardData;
    const { vendorRating } = this.props;
    const ratingViewLabel = ffRating ? vendorRating[ffRating - 1] : '';
    return (
      <div className={classes.generalDetailsContent}>
        <FieldRate
          isView={true}
          isFlex={true}
          labelStyles={{fontWeight: 500, fontSize: `${tokens.fontSize.caption}px`, fontStyle: 'italic'}}
          styles={{ fontSize: `${tokens.fontSize.caption}px` }}
          ratingViewLabel={ratingViewLabel}
          value={ffRating}
          disabled={true}
        />
      </div>
    );
  };

  render() {
    const {
      classes,
      cardData,
      originChargesValue,
      destinationChargesValue,
      freightChargesValue,
      freeDaysKeys,
    } = this.props;
    const freightData = cardData?.chargeDetails?.freightCharges;
    const originData = cardData?.chargeDetails?.originCharges;
    const destinationData = cardData?.chargeDetails?.destinationCharges;
    if (!cardData) return;
    return (
      <div
        className={classes.parentDiv}
        style={cardData.isDeletedByShipper ? { opacity: 0.6 } : undefined}
      >
        <div style={{ maxWidth: '200px', minWidth: '185px' }}>
          {this.renderRow1()}
          {this.renderRow2()}
          {this.renderRow3()}
          {freightChargesValue.length > 0 && (
            <div
              className={classes.colStyle}
              style={{ height: this.props.getColumnHeight(freightChargesValue) }}
            >
              {this.renderValues(freightChargesValue, freightData)}
            </div>
          )}
          {originChargesValue.length > 0 && (
            <div
              className={classes.colStyle}
              style={{ height: this.props.getColumnHeight(originChargesValue) }}
            >
              {this.renderValues(originChargesValue, originData)}
            </div>
          )}
          {destinationChargesValue.length > 0 && (
            <div
              className={classes.colStyle}
              style={{ height: this.props.getColumnHeight(destinationChargesValue) }}
            >
              {this.renderValues(destinationChargesValue, destinationData)}
            </div>
          )}
          {freeDaysKeys.length > 0 && (
            <div
              className={classes.colStyle}
              style={{ height: this.props.getColumnHeight(freeDaysKeys) }}
            >
              {this.renderFreeDays()}
            </div>
          )}
          {this.renderTotal()}
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ masterData }) => ({
  currency: masterData.currencySymbols,
  permissions: masterData.permissions,
  showInquiryComments: masterData.modules.show_inquiry_comments,
  isParentOrg: masterData?.isParentOrg,
  userCurrency: masterData?.userData?.user_metadata?.user_currency,
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetFilters,
      applyFilter,
    },
    dispatch
  );
const BidCardShipperStyled = injectSheet(styles)(Form.create()(BidCardShipper));
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BidCardShipperStyled));
